import { axiosIdentityInstance } from "config";
import { useAxiosQuery, useAxiosMutation } from "hooks";
import { useQueryClient } from "react-query";

export type InProcessSettingsTab =
  | "all-current-patients"
  | "in-process"
  | "observation";

export type InProcessSettingsPatientFilter =
  | "All"
  | "AssignedToMe"
  | "Unassigned";

export type InProcessSettingsSortFilter = "room" | "createdAt";

export type InProcessSettingsDto = {
  defaultTab: InProcessSettingsTab;
  patients: InProcessSettingsPatientFilter;
  sortField: InProcessSettingsSortFilter;
  descending: boolean;
  needsPrepToTop: boolean;
};

export const defaultInProcessSettings: InProcessSettingsDto = {
  defaultTab: "all-current-patients",
  patients: "All",
  sortField: "room",
  descending: false,
  needsPrepToTop: false,
};

function normalizeSettings(
  settings?: InProcessSettingsDto
): InProcessSettingsDto {
  if (!settings) return defaultInProcessSettings;

  return {
    ...defaultInProcessSettings,
    ...settings,
  };
}

function useInProcessSettingsQuery() {
  return useAxiosQuery(["inProcessUserSettings"], async () => {
    const { data } = await axiosIdentityInstance.get<InProcessSettingsDto>(
      "v1/user-settings/in-process"
    );

    return normalizeSettings(data);
  });
}

function useSaveInProcessSettings() {
  const queryClient = useQueryClient();

  return useAxiosMutation(
    ["saveInProcessUserSettings"],
    async (settings: InProcessSettingsDto) => {
      const { data } = await axiosIdentityInstance.post<InProcessSettingsDto>(
        "v1/user-settings/in-process",
        settings
      );

      return normalizeSettings(data);
    },
    {
      onSuccess: (saved) => {
        queryClient.setQueryData(
          ["inProcessUserSettings"],
          normalizeSettings(saved)
        );
      },
    }
  );
}

export { useInProcessSettingsQuery, useSaveInProcessSettings };
